import { LockOutlined } from '@ant-design/icons';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Checkbox, Flex, Form, Image, Radio, Space, Table, Tooltip, Typography } from 'antd';
import { IExcelColumn } from 'antd-table-saveas-excel/app';
import { ColumnsType } from 'antd/es/table';
import Link from 'antd/es/typography/Link';
import { CheckboxProps } from 'antd/lib';
import dayjs from 'dayjs';
import ExcelJS from 'exceljs';
import { useEffect, useState } from 'react';
import IcMoveTicket from '../../../assets/images/diagram/ic-move-ticket.svg';
import IcMoveToast from '../../../assets/images/diagram/ic-move-toast.svg';
import iconDrop from '../../../assets/images/diagram/icon-drop.svg';
import icEdit from '../../../assets/images/ic-edit.svg';
import iconExport from '../../../assets/images/ic-excel.svg';
import ModalInfoInsurance from '../../../components/Modal/ModalInfoInsurance';
import { Constant, USER_GROUP, YearFormat } from '../../../config/constant';
import { formattedPrice, getStatusBooking, imageStatusTicket, isWaitingBooking } from '../../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { selectAuth } from '../../../redux/slice/authSlice';
import { getDataBookingSeat } from '../../../redux/slice/bookings/bookingTicketSlice';
import { resetPriceBooking } from '../../../redux/slice/bookings/createBookingSlice';
import {
  getListCustomerBooking,
  getListHistoryBooking,
  listBookingSelector,
  resetDataMoveTicket,
  resetListBookingDetail,
  setIsShowAllFloor,
} from '../../../redux/slice/bookings/listBooking';
import { listBookingRenderSelector, setIsShowNewBooking } from '../../../redux/slice/bookings/listBookingRender';
import { getListBookingDetail, listDetailTicketSelector } from '../../../redux/slice/bookings/listDetailTicketSlice';
import {
  getAvailableSeat,
  moveTicketSelector,
  resetListAvailableSeat,
  resetMoveTicket,
  setDataMoveTicket,
  setIsMoveTicketWaiting,
} from '../../../redux/slice/bookings/moveTicketSlice';
import ModalBooking from '../ModalBooking';
import ModalBookingDetail from '../ModalBookingDetail';
import ModalHistoryBooking from '../ModalHistoryBooking';
import ModalChangeBooking from '../changeBooking/ModalChangeBooking';
import BusDiagramBookingRender from '../diagrams/BusDiagramBookingRender';
import { printTicketSelector } from '../../../redux/slice/bookings/printTicketSlice';

const options = [
  { label: 'Tất cả trạng thái', value: '' },
  { label: 'Đang giữ chỗ', value: 'reserve' },
  { label: 'Đã thanh toán', value: 'paid' },
  { label: 'Đã hủy', value: 'cancel' },
];
function CustomerList({ listBooking, formSearch, activeKey, statusFloor, setStatusFloor, refs }: any) {
  const {
    listCustomerBooking,
    extra,
    loading: loadingDetail,
    bookingData,
    isShowAllFloor,
    isMoveTicket,
  } = useAppSelector(listBookingSelector);
  const { listBookingDetail, listBookingDetailSeat, seat_number, loadingListBookingDetail } =
    useAppSelector(listDetailTicketSelector);
  const {
    status: statusMoveTicket,
    isMoveTicket: isMoveTicketWaiting,
    dataMoveTicket,
  } = useAppSelector(moveTicketSelector);
  const {
    listBookingRender,
    isShowNewBooking,
    loading: loadingBookingRender,
  } = useAppSelector(listBookingRenderSelector);
  const { isPrintTicket } = useAppSelector(printTicketSelector);
  const { group } = useAppSelector(selectAuth);
  const [busTypeData, setBusTypeData] = useState<any>();
  const dispatch = useAppDispatch();
  const [filterStatus, setFilterStatus] = useState<any>('');
  const [isDetail, setIsDetail] = useState(false);
  const [openDetail, setOpenDetail] = useState(false);
  const [timeManage, setTimeManage]: any = useState<any>([]);
  const [selectedTicketCodes, setSelectedTicketCodes] = useState<string[]>([]);
  const [openInfoInsurance, setOpenInfoInsurance] = useState(false);
  const [openModalBookingDetail, setOpenModalBookingDetail] = useState(false);
  const [isChangeTicket, setIsChangeTicket] = useState(false);
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const [openModalChangeBooking, setOpenModalChangeBooking] = useState(false);
  const [showAllFLoor, setShowAllFloor] = useState<boolean>(false);
  const [showNewBooking, setShowNewBooking] = useState<boolean>(true);
  const [dataPolicy, setDataPolicy] = useState<any>();
  const [dataExportCsv, setDataExportCsv] = useState<any>([]);
  const searchDateBooking = dayjs(Form.useWatch('date_booking', formSearch)).format(YearFormat);
  const dateSelect = dayjs(Form.useWatch('date_booking', formSearch));
  const timeBooking = dayjs(
    `${listBooking?.schedule?.arrive_date}T${listBooking?.schedule?.arrive_time}`,
    'DD/MM/YYYYTHH:mm:ss',
  );
  const closeBefore = listBooking?.schedule?.close_before_time
    ? dayjs(`${listBooking?.schedule?.close_before_time}`)
    : null;
  const now = dayjs();
  const isBooking = timeBooking.isBefore(now);
  const isDepart = !isBooking && listBooking?.trip?.status === 'departed';
  const getDetailBooking = (record: any) => {
    setDataPolicy(record?.policy?.insurance_policy);
    if (record?.status === 'cancel') {
      dispatch(
        getListBookingDetail({
          ticket_code: record?.ticket_code,
          is_diagram: false,
        }),
      );
      dispatch(
        getListHistoryBooking({
          keyword: record?.ticket_code,
        }),
      );
      setOpenModalHistory(true);
    } else {
      setIsDetail(true);
      dispatch(
        getListBookingDetail({
          ticket_code: record?.ticket_code,
          is_diagram: false,
        }),
      );
      setOpenDetail(true);
    }
  };
  const onMoveTicket = (record: any) => {
    dispatch(setIsMoveTicketWaiting(true));
    const dataSearchValue = {
      old_ticket_codes: record?.ticket_code,
      depart_date: searchDateBooking,
      segment_id: record?.segment_id,
      is_move_waiting: true,
      group_seat: record?.group_seat ? record?.group_seat : undefined,
    };
    dispatch(
      setDataMoveTicket({
        ticket_code: record?.ticket_code,
        segment_id: record?.segment_id,
        depart_date: searchDateBooking,
        pickup_location_id: record?.pickup_location?.id ?? undefined,
        drop_off_location_id: record?.drop_off_location?.id ?? undefined,
        pickup_extra: record?.pickup_extra ?? undefined,
        drop_off_extra: record?.drop_off_extra ?? undefined,
      }),
    );
    dispatch(getAvailableSeat(dataSearchValue));
    if (isMoveTicket) {
      dispatch(setIsMoveTicketWaiting(false));
    }
  };

  const columns1: ColumnsType<any> = [
    {
      title: 'Mã đặt vé',
      dataIndex: '',
      key: 'ticket_code',
      width: '190px',
      render: (record) => (
        <Space size="middle">
          {listBooking?.contract?.code ? (
            <FontAwesomeIcon icon={faCircle} className={`green`} size="xs" />
          ) : (
            <>
              <img src={imageStatusTicket(record)} alt="" />
              <Typography>
                {record?.status === 'reserve' && record?.source === 'openapi' ? '' : record?.ticket_code}
              </Typography>
            </>
          )}
        </Space>
      ),
      sorter: (a: any, b: any) => a?.ticket_code.localeCompare(b?.ticket_code),
    },
    {
      title: 'Hành khách',
      dataIndex: '',
      key: 'customer_name',
      width: '210px',
      render: (text, record) => (
        <div>
          <Typography className="fs-16 fw-500" style={{ color: '#4F5662' }}>
            {record?.customer_name}
          </Typography>
          <Typography className="fs-14 fw-500" style={{ color: '#667085' }}>
            {record?.customer_phone}
          </Typography>
        </div>
      ),
    },
    {
      title: 'Đón tại',
      dataIndex: 'pickup_location',
      key: 'pickup_location',
      width: '280px',
      render: (text, record) => (
        <div>
          {record?.start_location ? (
            <>
              <Typography className="fs-16 fw-500" style={{ color: '#4F5662' }}>
                {`${record?.start_location}`}
              </Typography>
              <Typography className="fs-14 fw-500" style={{ color: '#667085' }}>
                {record?.pickup_extra ? '' : text?.address}
              </Typography>
            </>
          ) : (
            ''
          )}
        </div>
      ),
    },
    {
      title: 'Trả tại',
      dataIndex: 'drop_off_location',
      key: 'drop_off_location',
      width: '280px',
      render: (text, record) => (
        <div>
          {record?.end_location ? (
            <>
              <Typography className="fs-16 fw-500" style={{ color: '#4F5662' }}>
                {`${record?.end_location}`}
              </Typography>
              <Typography className="fs-14 fw-500" style={{ color: '#667085' }}>
                {record?.drop_off_extra ? '' : text?.address}
              </Typography>
            </>
          ) : (
            ''
          )}
        </div>
      ),
    },
    {
      title: 'Nguồn vé',
      dataIndex: 'orderer',
      key: 'orderer',
      width: '160px',
      render: (text) => <Typography style={{ color: '#4F5662' }}>{text?.name}</Typography>,
    },
    listBooking?.schedule?.is_diagram
      ? {
          title: 'Ghế',
          dataIndex: 'seat_number',
          key: 'seat_number',
          width: '110px',
          render: (text) => <Typography style={{ color: '#4F5662' }}>{text}</Typography>,
        }
      : { width: 0 },

    !listBooking?.contract?.code
      ? {
          title: 'Thực thu',
          dataIndex: 'final_price',
          key: 'final_price',
          width: '110px',
          sorter: (a: any, b: any) => b?.final_price - a?.final_price,
          render: (text) => <Typography style={{ color: '#4F5662' }}>{formattedPrice(text)}</Typography>,
        }
      : {
          width: '0',
        },
    {
      title: 'Phải thu',
      dataIndex: '',
      key: 'receivable',
      width: '110px',
      render: (record) => <Typography style={{ color: '#4F5662' }}>{record?.receivable}</Typography>,
      sorter: (a: any, b: any) => a?.receivable - b?.receivable,
    },
    !listBooking?.schedule?.is_diagram
      ? {
          title: ' ',
          dataIndex: 'action',
          key: 'action',
          render: (_, record: any) => (
            <Space size="middle">
              {selectedTicketCodes?.length > 1 ? (
                <Tooltip title="Chuyển vé">
                  <Link
                    onClick={() => {
                      dispatch(
                        getDataBookingSeat({
                          ticket_codes: selectedTicketCodes,
                        }),
                      );
                      setOpenModalChangeBooking(true);
                    }}
                  >
                    <Image width={17} height={17} className="icon-edit mr-20" src={IcMoveTicket} preview={false} />
                  </Link>
                </Tooltip>
              ) : (
                <div className="d-flex gap-x-12 items-center">
                  <Tooltip title="Chỉnh sửa">
                    <Link
                      onClick={() => {
                        getDetailBooking(record);
                      }}
                    >
                      <Image width={17} height={17} className="icon-edit mr-20" src={icEdit} preview={false} />
                    </Link>
                  </Tooltip>
                  {!listBooking?.schedule?.is_diagram && record?.status !== 'cancel' ? (
                    <Tooltip title="Chuyển vé">
                      <Link
                        onClick={() => {
                          setOpenModalChangeBooking(true);
                          dispatch(
                            getDataBookingSeat({
                              ticket_codes: [record?.ticket_code],
                            }),
                          );
                        }}
                      >
                        <Image width={17} height={17} className="icon-edit mr-20" src={IcMoveTicket} preview={false} />
                      </Link>
                    </Tooltip>
                  ) : (
                    ''
                  )}
                  {isWaitingBooking(listBooking?.schedule) && group !== USER_GROUP.AGENT ? (
                    <Tooltip title="Xếp chỗ">
                      <Link
                        onClick={() => {
                          onMoveTicket(record);
                        }}
                      >
                        <Image width={17} height={17} className="icon-edit mr-20" src={iconDrop} preview={false} />
                      </Link>
                    </Tooltip>
                  ) : (
                    ''
                  )}
                </div>
              )}
            </Space>
          ),
          align: 'center',
          width: '60px',
        }
      : {
          width: '50px',
        },
  ];

  const rowSelection = {
    selectedRowKeys: selectedTicketCodes,
    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
      setSelectedTicketCodes(selectedRowKeys as string[]);
    },
    getCheckboxProps: (record: any) => ({
      disabled: false,
    }),
  };

  const columnsExport: IExcelColumn[] = [
    {
      title: 'Mã đặt vé',
      __excelTitle__: 'Mã đặt vé',
      dataIndex: 'ticket_code',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 15,
      },
    },
    {
      title: 'Họ và tên',
      dataIndex: 'customer_name',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
      },
      __excelTitle__: 'Họ và tên',
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'customer_phone',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 15,
      },
      __excelTitle__: 'Số điện thoại',
    },
    {
      title: 'Chặng',
      dataIndex: 'segment',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 25,
      },
      __excelTitle__: 'Chặng',
      width: 25,
    },
    {
      title: 'Đón tại',
      dataIndex: 'pickup_location',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 25,
      },
      __excelTitle__: 'Đón tại',
      width: 25,
    },
    {
      title: 'Trả tại',
      dataIndex: 'drop_off_location',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 25,
      },
      __excelTitle__: 'Trả tại',
      width: 25,
    },
    {
      title: 'Nhân viên đặt vé',
      dataIndex: 'orderer',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 22,
      },
      __excelTitle__: 'Nhân viên đặt vé',
      width: 22,
    },
    {
      title: 'Ghế',
      dataIndex: listBooking?.schedule?.is_diagram ? 'seat_number' : ' ',
      align: 'center',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 10,
      },
      __excelTitle__: 'Ghế',
    },

    {
      title: 'Giá vé',
      dataIndex: 'price',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 15,
      },
      __excelTitle__: 'Giá vé',
    },
    {
      title: 'Tiền thực thu',
      dataIndex: 'final_price',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 15,
      },
      __excelTitle__: 'Tiền thực thu',
    },
    {
      title: 'Phải thu',
      dataIndex: 'receivable',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 15,
      },
      __excelTitle__: 'Người thu',
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      __excelTitle__: 'Trang thái',
      __style__: {
        fontName: 'Times New Roman',
        fontSize: 14,
        border: true,
        borderColor: 'black',
        width: 15,
      },
    },
  ];
  const onChange: any = (e: any) => {
    setFilterStatus(e.target.value);
  };
  const onChangeFloor = (value: number | undefined) => {
    if (value && value <= 2) {
      setStatusFloor(value);
    }
  };
  const handleChangeShowFloor: CheckboxProps['onChange'] = (e) => {
    dispatch(setIsShowAllFloor(e.target.checked));
    setIsShowAllFloor(true);
  };
  const handleChangeShowNewBooking: CheckboxProps['onChange'] = (e) => {
    dispatch(setIsShowNewBooking(e.target.checked));
  };
  useEffect(() => {
    if (timeManage?.length) {
      let timers: NodeJS.Timeout[] = [];
      const handleUpdateStatus = async (): Promise<void> => {
        await dispatch(
          getListCustomerBooking({
            schedule_id: listBooking?.schedule?.id,
            depart_date: searchDateBooking,
            status: filterStatus,
            is_move_waiting: isWaitingBooking(listBooking?.schedule) ? true : false,
            type: 'list',
          }),
        );
      };
      const setTimer = (index: number): void => {
        const timerId: NodeJS.Timeout = setTimeout(() => {
          if (isDetail || isPrintTicket) {
            // CLEAR ALL TIMER
            timers.forEach(clearTimeout);
            return;
          }
          handleUpdateStatus();
          setTimer(index);
        }, Constant.TIMER_CUSTOMER);
        timers[index] = timerId;
      };
      // Start timers
      for (let i: number = 0; i < timeManage?.length; i++) {
        setTimer(i);
      }
      return (): void => {
        timers.forEach(clearTimeout);
      };
    }
  }, [timeManage, dispatch, searchDateBooking, listBooking, filterStatus, isDetail, isPrintTicket]);

  useEffect(() => {
    if (
      listBooking &&
      searchDateBooking &&
      ((+activeKey === 2 && listBooking?.schedule?.is_diagram) ||
        (+activeKey === 1 && !listBooking?.schedule?.is_diagram)) 
    ) {
      if (!listBooking?.schedule?.is_diagram) {
        setTimeManage([
          {
            id: listBooking?.schedule?.id,
          },
        ]);
      }
      dispatch(
        getListCustomerBooking({
          schedule_id: listBooking?.schedule?.id,
          depart_date: searchDateBooking,
          status: filterStatus,
          is_move_waiting: isWaitingBooking(listBooking?.schedule) ? true : false,
          type: 'list',
        }),
      );
    }
  }, [dispatch, filterStatus, listBooking, activeKey, searchDateBooking]);
  useEffect(() => {
    if (listCustomerBooking?.length) {
      const tmpListCustomerBooking = listCustomerBooking?.map((item: any) => {
        return {
          ...item,
          orderer: item?.orderer?.name,
          status: getStatusBooking(item?.status),
          segment: `${item?.start_location} - ${item?.end_location}`,
          pickup_location: item?.pickup_location?.name ?? item?.pickup_extra,
          drop_off_location: item?.drop_off_location?.name ?? item?.drop_off_extra,
          price_commission: item?.is_driver_pay && item?.orderer?.agent?.id ? item?.price : item?.price_commission,
        };
      });
      setDataExportCsv(tmpListCustomerBooking);
    } else {
      setDataExportCsv([]);
    }
  }, [listCustomerBooking]);

  const handleClick = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Danh sách hành khách');
    const header = columnsExport.map((col) => ({
      header: col.title,
      key: col.dataIndex as string,
    }));
    worksheet.columns = header;

    columnsExport.forEach((col, index) => {
      worksheet.getColumn(index + 1).width = col.width || 15;
    });
    header.forEach((_, index) => {
      const cell = worksheet.getCell(1, index + 1);
      cell.font = { name: 'Times New Roman', size: 12, bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '3AB54A' },
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' },
      };
    });
    worksheet.addRows(dataExportCsv);
    worksheet.eachRow((row, rowNumber) => {
      let hasData = false;
      if (rowNumber > 1) {
        row.eachCell((cell) => {
          if (cell) {
            hasData = true;
          }
        });
        if (hasData) {
          row.eachCell((cell) => {
            cell.font = { name: 'Times New Roman', size: 12 };
            cell.border = {
              top: { style: 'thin' },
              left: { style: 'thin' },
              bottom: { style: 'thin' },
              right: { style: 'thin' },
            };
          });
        }
      }
    });
    const lastRow = worksheet.addRow([]);
    lastRow.getCell(1).value = '@Bản quyền thuộc nhà xe Carlink ';
    lastRow.getCell(1).alignment = { vertical: 'middle', horizontal: 'left' };
    lastRow.getCell(1).font = { name: 'Times New Roman', size: 12 };
    const startColumnIndex = 2;
    const endColumnIndex = startColumnIndex + columnsExport.length - 1;
    worksheet.mergeCells(lastRow.number, 1, lastRow.number, endColumnIndex);
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Danh sách hành khách.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };
  const handleOkModalBookingDetail = () => {};
  const cancelModalBookingDetail = () => {
    setIsDetail(false);
    setOpenModalBookingDetail(false);
    dispatch(resetPriceBooking());
    dispatch(resetListBookingDetail());
  };
  const cancelChangBookingModal = () => {
    setOpenModalChangeBooking(false);
    dispatch(resetListAvailableSeat());
    dispatch(resetMoveTicket());
    dispatch(resetDataMoveTicket());
  };
  const handleOkChangeBooking = () => {};
  const cancelModal = () => {
    setIsDetail(false);
    setOpenDetail(false);
    dispatch(resetPriceBooking());
    setDataPolicy(undefined);
  };
  const handleOkModalBooking = () => {};
  const cancelModalHistory = () => {
    setOpenModalHistory(false);
  };

  useEffect(() => {
    if (statusMoveTicket === Constant.DEFAULT_STATUS) {
      setOpenModalChangeBooking(false);
      dispatch(resetMoveTicket());
      cancelChangBookingModal();
    }
  }, [statusMoveTicket]);
  return (
    <>
      {isWaitingBooking(listBooking?.schedule) ? (
        <>
          {dataMoveTicket?.ticket_code && isMoveTicketWaiting && (
            <div className="move-ticket-block">
              <Flex gap={8} className="block-ticket-content">
                <img src={IcMoveToast} alt="" />
                <span className="fs-16 fw-500 text-white">Bạn đang di chuyển vé</span>
              </Flex>
              <Flex gap={24} className="pr-24">
                <span className="fs-16 fw-500 text-white"> Mã vé:</span>
                <span className="fs-16 fw-500 text-white">{dataMoveTicket?.ticket_code}</span>
              </Flex>
              <Button
                className="btn-cancel"
                onClick={() => {
                  dispatch(setIsMoveTicketWaiting(false));
                  dispatch(resetMoveTicket());
                }}
              >
                Hủy
              </Button>
            </div>
          )}
          <div className="d-flex justify-between bus-diagram-block">
            {listBooking?.schedule?.bus_type?.seat_map?.count_floor === 2 ? (
              <div className="d-flex items-center" style={{ columnGap: '24px' }}>
                <div>
                  <Button
                    className={`btn-floor${statusFloor === 1 && !isShowAllFloor ? ' active' : ''}`}
                    onClick={() => onChangeFloor(1)}
                    disabled={isShowAllFloor}
                  >
                    Tầng 1
                  </Button>
                  <Button
                    className={`btn-floor${statusFloor === 2 && !isShowAllFloor ? ' active' : ''}`}
                    onClick={() => onChangeFloor(2)}
                    disabled={isShowAllFloor}
                  >
                    Tầng 2
                  </Button>
                </div>
                <Checkbox
                  value={showAllFLoor}
                  onChange={handleChangeShowFloor}
                  className="text-blue fw-500"
                  checked={isShowAllFloor ? isShowAllFloor : false}
                >
                  Hiển thị 2 tầng trên 1 trang
                </Checkbox>
              </div>
            ) : (
              <div></div>
            )}
            {listBooking?.count_segment > 1 ? (
              <div className="d-flex items-center">
                <Checkbox
                  value={showNewBooking}
                  onChange={handleChangeShowNewBooking}
                  className="text-blue fw-500"
                  checked={isShowNewBooking ? isShowNewBooking : false}
                >
                  Hiện tên khách mới nhất
                </Checkbox>
              </div>
            ) : (
              <></>
            )}
          </div>
          <BusDiagramBookingRender
            listBooking={listBooking}
            listBookingRender={listBookingRender}
            statusFloor={statusFloor}
            bookingData={bookingData}
            busTypeData={busTypeData}
            group={group}
            searchDateBooking={searchDateBooking}
            dateSelect={dateSelect}
            timeBooking={timeBooking}
            closeBefore={closeBefore}
            isMoveTicket={isMoveTicket}
            dataMoveTicket={dataMoveTicket}
            setBusTypeData={setBusTypeData}
            refs={refs}
            isShowAllFloor={isShowAllFloor}
            isShowNewBooking={isShowNewBooking}
            loadingBookingRender={loadingBookingRender}
            setOpenModalBookingDetail={setOpenModalBookingDetail}
            setIsDetail={setIsDetail}
            isBooking={isBooking}
            formSearch={formSearch}
            listBookingDetail={listBookingDetail}
            isDetail={isDetail}
            loading={loadingDetail}
            listBookingDetailSeat={listBookingDetailSeat}
            isMoveTicketWaiting={isMoveTicketWaiting}
            isWaitingCustomerList={true}
            listCustomerBooking={listCustomerBooking}
          />
        </>
      ) : (
        ''
      )}
      <div
        className={`table-booking ${
          listBooking?.count_segment === 1 || !listBooking?.schedule?.is_diagram ? 'mt-0' : 'mt-4'
        } `}
      >
        {!isWaitingBooking(listBooking?.schedule) ? (
          <>
            <Flex gap={12} className="justify-start items-center">
              <Button className="btn-export" onClick={() => handleClick()}>
                <img src={iconExport} alt="excel" />
                Xuất excel
              </Button>
              {extra?.is_lock_all && (
                <Flex gap={8}>
                  <Typography className="fs-16 fw-600 text-danger">Chuyến đã bị khóa</Typography>
                  <LockOutlined size={14} className="text-danger fs-14" />
                </Flex>
              )}
            </Flex>

            {!listBooking?.contract?.code && (
              <Radio.Group
                options={options}
                value={filterStatus}
                className="mt-3 fw-500 payment-checkbox-group customer-list"
                onChange={onChange}
              />
            )}
          </>
        ) : (
          ''
        )}
        {isWaitingBooking(listBooking?.schedule) ? (
          <Typography className="fs-16 text-black fw-600 mt-3">{`Danh sách hành khách không sơ đồ (${
            listCustomerBooking?.wait_bookings?.length ?? 0
          })`}</Typography>
        ) : (
          ''
        )}
        <Table
          locale={{
            triggerDesc: 'Sắp xếp giảm dần',
            triggerAsc: 'Sắp xếp tăng dần',
            cancelSort: 'Hủy sắp xếp',
          }}
          // loading={loadingCustomerBooking}
          dataSource={
            isWaitingBooking(listBooking?.schedule) && listCustomerBooking?.wait_bookings?.length
              ? listCustomerBooking?.wait_bookings
              : listCustomerBooking?.length > 0 && listBooking?.schedule?.id
              ? listCustomerBooking
              : []
          }
          rowKey="ticket_code"
          columns={columns1}
          className="list-bus mt-1"
          pagination={false}
          rowSelection={
            !listBooking?.schedule?.is_diagram
              ? {
                  type: 'checkbox',
                  ...rowSelection,
                }
              : undefined
          }
        />
      </div>
      <ModalBooking
        okText={'Lưu'}
        modalOpen={openDetail}
        onCancel={cancelModal}
        cancelText="Đóng"
        onOk={handleOkModalBooking}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
      />
      {isWaitingBooking(listBooking?.schedule) && (
        <ModalBookingDetail
          modalOpen={openModalBookingDetail}
          onCancel={cancelModalBookingDetail}
          cancelText={'Đóng'}
          onOk={handleOkModalBookingDetail}
          listBooking={listBooking}
          formSearch={formSearch}
          isDetail={isDetail}
          listBookingDetail={listBookingDetail}
          listBookingDetailSeat={listBookingDetailSeat}
          seat_number={seat_number}
          loading={loadingDetail}
          isDepart={isDepart}
          isBooking={isBooking}
          isChangeTicket={isChangeTicket}
          setIsChangeTicket={setIsChangeTicket}
          searchDateBooking={searchDateBooking}
        />
      )}
      <ModalHistoryBooking
        modalOpen={openModalHistory}
        onOk={() => setOpenModalHistory(false)}
        onCancel={cancelModalHistory}
        isCancel={true}
        listBooking={listBooking}
        listBookingDetail={listBookingDetail}
        loadingListDetail={false}
        historyDetail={listBookingDetail}
      />
      <ModalInfoInsurance
        modalOpen={openInfoInsurance}
        onCancel={() => setOpenInfoInsurance(false)}
        onOk={() => false}
        dataPolicy={dataPolicy}
      />
      <ModalChangeBooking
        okText={'Lưu'}
        modalOpen={openModalChangeBooking}
        onCancel={cancelChangBookingModal}
        cancelText={'Đóng'}
        onOk={handleOkChangeBooking}
        listBooking={listBooking}
        formSearch={formSearch}
        isDetail={isDetail}
        listBookingDetail={listBookingDetail}
        searchDateBooking={searchDateBooking}
      />
    </>
  );
}
export default CustomerList;
